import React from 'react'
import {
  VendorEvaluationCycleStatus as Status,
  VendorEvaluationConfidence as Confidence,
} from '@trustero/trustero-api-web/lib/vendormanagement/vendor_evaluation_cycle_pb'
import { Pill } from 'src/components/Reusable/Pill/Pill'

// An evaluation's status and confidence pills: the Evaluations tab's rows and
// the vendor Summary use the same ones.
export const STATUS_PILLS: Record<
  number,
  { label: string; color: string; bg: string }
> = {
  [Status.VENDOR_EVALUATION_CYCLE_STATUS_EVALUATING]: {
    label: 'Evaluating',
    color: '#026AA2',
    bg: '#F0F9FF',
  },
  [Status.VENDOR_EVALUATION_CYCLE_STATUS_RUNNING]: {
    label: 'Working',
    color: '#026AA2',
    bg: '#F0F9FF',
  },
  // Amber while something is owed inside the account; purple while the
  // vendor owes a questionnaire.
  [Status.VENDOR_EVALUATION_CYCLE_STATUS_WAITING_ON_APPROVAL]: {
    label: 'Waiting on approval',
    color: '#B54708',
    bg: '#FFFAEB',
  },
  [Status.VENDOR_EVALUATION_CYCLE_STATUS_WAITING_ON_REQUEST]: {
    label: 'Waiting on request',
    color: '#B54708',
    bg: '#FFFAEB',
  },
  [Status.VENDOR_EVALUATION_CYCLE_STATUS_WAITING_ON_VENDOR]: {
    label: 'Waiting on vendor',
    color: '#5925DC',
    bg: '#F4F3FF',
  },
  [Status.VENDOR_EVALUATION_CYCLE_STATUS_COMPLETED]: {
    label: 'Completed',
    color: '#027A48',
    bg: '#ECFDF3',
  },
  [Status.VENDOR_EVALUATION_CYCLE_STATUS_CANCELLED]: {
    label: 'Cancelled',
    color: '#667085',
    bg: '#F2F4F7',
  },
}

export const CONFIDENCE_PILLS: Record<
  number,
  { label: string; color: string; bg: string }
> = {
  [Confidence.VENDOR_EVALUATION_CONFIDENCE_HIGH]: {
    label: 'High',
    color: '#027A48',
    bg: '#ECFDF3',
  },
  [Confidence.VENDOR_EVALUATION_CONFIDENCE_MEDIUM]: {
    label: 'Medium',
    color: '#B54708',
    bg: '#FFFAEB',
  },
  [Confidence.VENDOR_EVALUATION_CONFIDENCE_LOW]: {
    label: 'Low',
    color: '#B42318',
    bg: '#FEF3F2',
  },
}

export const CyclePill = ({
  value,
}: {
  value?: { label: string; color: string; bg: string }
}): JSX.Element | null =>
  value ? (
    <Pill
      label={value.label}
      $fontColor={value.color}
      backgroundColor={value.bg}
      $size="small"
    />
  ) : null
